import React from 'react';
import memberLogo from '../assets/minnesota-state-member-logo.png';

export default function Footer() {
  return (
    <footer style={{ marginTop: 40, backgroundColor: '#463066', color: '#fff', padding: '1rem 2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 1200, margin: '0 auto', gap: '1rem', flexWrap: 'wrap' }}>
        <img src={memberLogo} alt="Minnesota State. Minnesota State University, Mankato, A member of Minnesota State" className="footer-logo" />
        <div style={{ fontSize: '.875rem' }}>© 2005-{new Date().getFullYear()} Minnesota State University, Mankato</div>
      </div>
    </footer>
  );
}
